
export class TenantDto {
    id!:string;
    name!:string;
    displayName!:string;
    isConfirmed!: boolean;
}

export class UserTenantDto {
    id!: string;
    userId!:string;
    tenantId!:string;
    tenantName!:string;
    isConfirmed!: boolean;
    isExpanded!: boolean;
}

export class SelectTenantDto {
    id!:string;
    name!:string;
    displayName!:string;
    isSelected!: boolean;
}

export class TenantResolved {
    tenantDto!:TenantDto;
    error?:any
}

export class SubTenantDto {
    id!:string;
    tenantId!:string;
    tenantName!:string;
    subName!:string;
    subId!:string;
}

export class TenantGroupRoleDto {
    id!:string;
    name!: string;
    displayName!:string;
    permissions!:string;
}

export class TenantGroupRoleUserDto {
    roleId!:string;
    userId!:string;
    userName!:string;
    name!: string;
}

// public Guid RoleId { get; set; }
// public Guid UserId { get; set; }
// public string UserName { get; set; }
// public string Name { get; set; }

/*
public Guid UserId { get; set; }
        public Guid TenantId { get; set; }
        public string TenantName { get; set; }
        public string SubName { get; set; }
        public Guid SubId { get; set; }
*/